import { Action } from 'redux';

//
// actions coming from bridge (backward compatible with edison)
// no builder is required as they will be generated by bridge
//
export const REDIRECT_TO = 'REDIRECT_TO';
export type REDIRECT_TO_TYPE = typeof REDIRECT_TO;
export interface IRedirectAction extends Action<REDIRECT_TO_TYPE> {
  type: REDIRECT_TO_TYPE;
  payload: {
    url: string;
    target?: '_blank';
  };
}

export const ROUTE = 'ROUTE';
export type ROUTE_TYPE = typeof ROUTE;
export interface IRouteAction extends Action<ROUTE_TYPE> {
  type: ROUTE_TYPE;
  payload: string;
}

export const REDIRECT_CHECKOUT = 'REDIRECT_CHECKOUT';
export type REDIRECT_CHECKOUT_TYPE = typeof REDIRECT_CHECKOUT;
export interface IRedirectCheckoutAction extends Action<REDIRECT_CHECKOUT_TYPE> {
  type: REDIRECT_CHECKOUT_TYPE;
  payload: {
    productId: number;
    coupon?: string;
  };
}

export type IAppBridgeActions = IRedirectAction | IRouteAction | IRedirectCheckoutAction;
